import { Column } from "primereact/column";
import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { Tag } from "primereact/tag";
import * as Fa from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { fetchData } from "../../../Services/GlobalService";
import Loader from "../../../Components/Loader";

const SurchargeDefAllRecords = () => {
  const ControllerName = "SurchargeDefinition";

  const EndPoint = {
    GetAllSurchargeData: "GetAllSurchargeData"
  };

  const [loading, setLoading] = useState(false);
  const [surchrgData, setSurchrgData] = useState([]);

  const getAllSurChrgData = async () => {
    try{
      setLoading(true);
      const res = await fetchData(ControllerName,EndPoint.GetAllSurchargeData,``);
      setSurchrgData(res.Data);
      console.log(res.Data,"getAllSurChrgData");
    }catch(ex){
      console.log(ex,"getAllSurChrgData");
    }finally{
      setLoading(false);
    }
  }
  const nav = useNavigate();
  
  const renderAction = (rowdata: any) => {
    return (
      <>
        <div className="action-icon">
          <div
            className="d-inline"
            data-toggle="tooltip"
            data-placement="bottom"
            title="View"
          >
            <button
              className="grid-icon"
              onClick={() => {
                nav(
                  `/Master/SurchargeDefinition/View?surchrgcode=${encodeURIComponent(
                        rowdata.MASTER_SURCHRG_CODE)}`
                );
              }}
            >
              <Fa.FaEye />
            </button>
          </div>
        </div>
      </>
    );
  };

  useEffect(()=>{
    getAllSurChrgData();
  },[])

  if(loading){
    return(<Loader/>)
  }else{
    return (
    <>
      <main>
        <div className="col-12 mb-5">
          <div className="col-12">
            <nav aria-label="breadcrumb" className="drop-in">
              <ol className="breadcrumb mx-0">
                <li className="breadcrumb-item">Masters</li>
                <li className="breadcrumb-item active" aria-current="page">
                  Surcharge Definition
                </li>
              </ol>
            </nav>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <h3 className="py-2">Surcharge Definition</h3>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="text-end">
                <button type="button" className="btn anime-btn" onClick={()=>nav("/Master/SurchargeDefinition/View")}>
                  Add New
                </button>
              </div>
            </div>
          </div>

          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="DataTable">
              <DataTable
                value={surchrgData}
                paginator
                rows={10}
                filterDisplay="row"
                scrollable
                rowsPerPageOptions={[10, 25, 50]}
                scrollHeight="80vh"
                showGridlines
                stripedRows
                tableStyle={{ minWidth: "60rem" }}
              >
                <Column
                  field="MASTER_SURCHRG_CODE"
                  header="Surcharge Code"
                  filter
                  filterMatchMode="contains"
                  filterPlaceholder="Search Here..."
                ></Column>
                <Column
                  field="SURCHARGE_DESC"
                  header="Surcharge Desc"
                  filter
                  filterMatchMode="contains"
                  filterPlaceholder="Search Here..."
                ></Column>
                <Column
                  field="START_DATE"
                  header="Start Date"
                  filter
                  filterMatchMode="contains"
                  filterPlaceholder="Search Here..."
                ></Column>
                <Column
                  field="END_DATE"
                  header="End Date"
                  filter
                  filterMatchMode="contains"
                  filterPlaceholder="Search Here..."
                ></Column>
                <Column
                  field="IS_ACTIVE"
                  header="Status"
                />
                <Column body={renderAction} field="" header="Action"></Column>
              </DataTable>
            </div>
          </div>
        </div>
      </main>
    </>
    );
  }
};

export default SurchargeDefAllRecords;
